import MeasurementsInput from "../../measuring/measurements-input";
import Modal from "../../modal";
import React from "react";
import { useTask } from "shared/hooks/use-task";
import { MeasurementsProvider } from "components/shipment-editor/contexts/measurements-provider";

export const EditMeasurementsModal = ({
    sourcePage,
    open,
    onClose,
    existingMeasurements,
    showTabs,
    activePositions,
    selectedTabOverride,
    setSelectedTabOverride,
}) => {
    const { task } = useTask();

    return (
        <Modal
            show={open}
            onClose={onClose}
        >
            <h2>Edit dimensions</h2>
            <MeasurementsProvider>
                <MeasurementsInput
                    sourcePage={sourcePage}
                    editOnly
                    showTabs={showTabs}
                    activePositions={activePositions}
                    selectedTabOverride={selectedTabOverride}
                    setSelectedTabOverride={setSelectedTabOverride}
                    shipmentKey={task.shipmentKey}
                    measurementsFromPhotography={existingMeasurements}
                    getSelectedUpcs={[task.context.upc]}
                    shipmentData={{
                        hasMetricMeasurementsOnly: task.cxHClientHasMetricMeasurementsOnly,
                        key: task.shipmentKey,
                        shipmentType: task.shipmentType,
                    }}
                />
            </MeasurementsProvider>
            <div className="m-t-12 align-items-center justify-content-center">
                <button
                    className="button -primary"
                    onClick={onClose}
                >
                    Close
                </button>
            </div>
        </Modal>
    );
};
